var React = require('react');

function MenuCloseInline (props) {
    return React.createElement("svg",props,React.createElement("path",{"fillRule":"evenodd","clipRule":"evenodd","d":"M5.67165 4L4.00011 5.67154L10.3292 12.0006L4 18.3299L5.67154 20.0014L12.0008 13.6722L18.3276 19.999L19.9992 18.3275L13.6723 12.0006L19.999 5.6739L18.3275 4.00236L12.0008 10.3291L5.67165 4Z","fill":"currentColor"}));
}

MenuCloseInline.defaultProps = {"width":"24","height":"24","viewBox":"0 0 24 24","fill":"none"};

module.exports = MenuCloseInline;

MenuCloseInline.default = MenuCloseInline;
